import { useData } from "./DataContext.js";
import { style } from "./Style.js";

import { Droppable } from "react-beautiful-dnd";

import ItemDraggable from "./ItemDraggable.js";

export default function ItemCollectionDroppable (props)
{
    const gData = useData();

    const itemDraggables = props.itemStruct.collectionIds.map((itemId, index) => {
	let state = "none";
	if (props.itemStruct.type === "bp")
	{
	    if (gData.state.items[itemId].appliedToCharIds.includes(props.itemStruct.charId)) state = "applied";
	    else if (gData.state.items[itemId].missedToCharIds.includes(props.itemStruct.charId)) state = "missed";
	}
	return (<ItemDraggable key={itemId} index={index} itemId={itemId} state={state}/>);
    });

    const droppableId = "itemCollection";

    let text = (<></>);
    const noItem = props.itemStruct.collectionIds.length === 0 && props.itemStruct.selectionIds.filter((id) => id !== null).length === 0;
    
    if (noItem)
    {
	if (props.itemStruct.type === "info")
	{
	    const charName = gData.content.chars[props.itemStruct.charId].firstName;
	    const determiner = RegExp("^[aeiouy]", "i").test(charName) ? "d'" : "de ";
	    text = (<div>Vous n'avez encore collecté aucune information vous permettant de résoudre le problème {determiner}{charName}. Revenez plus tard !</div>);
	}

	else if (props.itemStruct.type === "bp")
	{
	    const charName = gData.content.chars[props.itemStruct.charId].firstName;
	    text = (<div>Vous n'avez encore collecté aucun conseil que vous pourriez donner à {charName}. Revenez plus tard !</div>);
	}
    }
    
    return (
	<Droppable droppableId={droppableId}>
	    {(provided, snapshot) => {
		const borderColor = noItem ? "" : "border border-2 border-secondary-subtle ";
		const bgColor = snapshot.isDraggingOver ? "bg-secondary-subtle " : "bg-white ";
		return (
		    <div>
			<div style={ style.modal.droppable.style } className={"position-relative rounded mt-2 p-1 d-flex flex-column align-items-center " + bgColor + borderColor} ref={provided.innerRef} { ...provided.droppableProps }>
			    <div className="w-75 position-absolute start-50 top-50 translate-middle text-secondary text-center fs-4 text-danger">{text}</div>
			    {itemDraggables}
			    {provided.placeholder}
			</div>
		    </div>
		);
	    }}
	</Droppable>
    );
}
